import dayjs from "dayjs";
import { Timesheet } from "../types/timesheet";

const KEY = "ytr_timesheets_v1";

const readAll = (): Timesheet[] => {
    const raw = localStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as Timesheet[]) : [];
};

const writeAll = (items: Timesheet[]) => {
    localStorage.setItem(KEY, JSON.stringify(items));
};

// ✅ Week start (Monday) from any date string YYYY-MM-DD
export const getWeekStart = (dateStr: string): string => {
    const d = dayjs(dateStr);
    const day = d.day(); // 0 Sun ... 6 Sat
    const diffToMonday = (day + 6) % 7; // Mon =>0, Sun=>6
    return d.subtract(diffToMonday, "day").format("YYYY-MM-DD");
};

export const listTimesheets = (): Timesheet[] => {
    return readAll().sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1));
};

export const listTimesheetsByEmployee = (employeeId: string): Timesheet[] => {
    return listTimesheets().filter((t) => t.employeeId === employeeId);
};

export const upsertTimesheet = (ts: Timesheet): Timesheet => {
    const all = readAll();
    const now = new Date().toISOString();
    const next: Timesheet = { ...ts, updatedAt: now };

    const idx = all.findIndex((x) => x.id === ts.id);
    if (idx >= 0) all[idx] = next;
    else all.push(next);

    writeAll(all);
    return next;
};

export const deleteTimesheet = (id: string) => {
    writeAll(readAll().filter((t) => t.id !== id));
};

// ✅ Keep this name consistent everywhere
export const createBlankTimesheet = (params: {
    employeeId: string;
    employeeName: string;
    weekStart: string;
}): Timesheet => {
    return {
        id: crypto.randomUUID(),
        employeeId: params.employeeId,
        employeeName: params.employeeName,
        weekStart: params.weekStart,
        status: "DRAFT",
        notes: "",
        lines: [
            {
                project: "Internal",
                task: "Work",
                mon: 0,
                tue: 0,
                wed: 0,
                thu: 0,
                fri: 0,
                sat: 0,
                sun: 0,
            },
        ],
        updatedAt: new Date().toISOString(),
    };
};

export const calcTotalHours = (ts: Timesheet): number => {
    const days = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"] as const;

    return (ts.lines || []).reduce((sum, line) => {
        const lineTotal = days.reduce((s, d) => s + (Number(line[d]) || 0), 0);
        return sum + lineTotal;
    }, 0);
};